import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerApplyPriceListUerRatioRowsGql } from '../../workOrderQueries';

interface IUseUerApplyPriceListUerRatioRows {
    uerBaseRowId: number;
    onSuccess: () => void;
}

const requestId = 'uerApplyPriceListUerRatioRows';

export const useUerApplyPriceListUerRatioRows = (props: IUseUerApplyPriceListUerRatioRows) => {
    const dispatch = useDispatch();
    const { uerBaseRowId, onSuccess } = props;

    const [uerApplyPriceListUerRatioRowsReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerApplyPriceListUerRatioRowsReset(undefined);
        onSuccess();
    }, [onSuccess, uerApplyPriceListUerRatioRowsReset]);

    const [, uerApplyPriceListUerRatioRowsStatus, , uerApplyPriceListUerRatioRowsRequest] = useRequest({
        requestId,
        query: uerApplyPriceListUerRatioRowsGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerApplyPriceListUerRatioRowsMakeRequest = useCallback(
        (ratioRowIds: number[]) => {
            dispatch(uerApplyPriceListUerRatioRowsRequest({ uerBaseRowId, ratioRowIds }));
        },
        [dispatch, uerApplyPriceListUerRatioRowsRequest, uerBaseRowId],
    );

    return {
        uerApplyPriceListUerRatioRowsStatus,
        uerApplyPriceListUerRatioRowsMakeRequest,
    };
};
